<form class="search-container" title="Search for articles">
  <mat-form-field class="full-w">
    <mat-label>Search</mat-label>
    <input matInput type="text" class="input-field" [formControl]="searchControl" [matAutocomplete]="searchAuto"
      (keyup)="searchOnEnter($event)">
    <mat-icon matPrefix>search</mat-icon>
    <mat-autocomplete #searchAuto="matAutocomplete" (optionSelected)="navigateToArticle($event)">
      @for (option of articleTitles; track option) {
        <mat-option class="search-option" [value]="option">
          <mat-icon matPrefix>search</mat-icon>
          <span [innerHTML]="option.title"></span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
